export const enum InvoiceTypeEnum {
	NO_EMIT = 1,
	EMIT = 3,
}
